import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { d as defineCustomElement$7 } from './p-D5W-FK48.js';
import { d as defineCustomElement$6 } from './p-BDIehgMZ.js';
import { d as defineCustomElement$5 } from './p-DKss2Fy6.js';
import { d as defineCustomElement$4 } from './p-lnuA9A6c.js';
import { d as defineCustomElement$3 } from './p-Trmgzgcp.js';
import { d as defineCustomElement$2 } from './p-KbTC_jnR.js';

const tileCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host h3{font-family:Open Sans;font-size:1.125rem;font-weight:400;letter-spacing:-.0008em;line-height:1.5rem;margin:0;padding:0}:host p{font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;margin:0;padding:0}:host(.header),:host(.header-button){border-bottom:1px solid var(--jw-theme-surface-border-border-color);padding:1.5rem}::slotted([slot=footer]){padding-left:1.5rem;padding-right:1.5rem}:host(.tabbed-header) wui-tabs{padding-left:1.5rem;padding-right:1.5rem;padding-top:.5rem}:host(.tile-container){background-color:var(--jw-theme-surface-tile-bg-color);border:1px solid var(--jw-theme-surface-border-border-color);border-radius:.375rem;display:flex;flex-direction:column;max-width:100%;position:relative;width:100%}.horizontal-padding{padding-left:1.5rem;padding-right:1.5rem}.vertical-padding{padding-bottom:1.5rem;padding-top:1.5rem}";

const WuiTileTextHeader$1 = /*@__PURE__*/ proxyCustomElement(class WuiTileTextHeader extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.headerTitle = '';
    }
    render() {
        return (h(Host, { key: 'ac59135a61f3304c0ea3d5905eec1cafc47d91cd', class: this.button ? 'header-button' : 'header' }, h("wui-layout", { key: '2f4bda6bf57f84cfb8ba716d59d40b8a19a9c5d1', class: this.button ? 'button-header' : '', type: this.button ? 'text-button-group' : 'text-group' }, h("h3", { key: '42495a0f6fff916775ffed57dfbad1c245c5a259' }, this.headerTitle), this.button && h("wui-button", { key: 'a1ba84767902a174cbb48f46a6da23958991a47e', ...this.button }))));
    }
    static get style() { return tileCss; }
}, [257, "wui-tile-text-header", {
        "headerTitle": [1, "header-title"],
        "button": [16]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-tile-text-header", "wui-button", "wui-icon", "wui-layout", "wui-loader", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-tile-text-header":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTileTextHeader$1);
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-layout":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiTileTextHeader = WuiTileTextHeader$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTileTextHeader, defineCustomElement };
